import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userDetails: null, // Store user details here
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserDetails: (state, action) => {
      state.userDetails = action.payload; // Store user details
    },
    clearUserDetails: (state) => {
      state.userDetails = null; // Clear user details
    },
  },
});

// Export actions
export const { setUserDetails, clearUserDetails } = userSlice.actions;

// Export reducer
export default userSlice.reducer;
